export enum RequirementCategory {
  AttireAndGrooming = 'Attire & Grooming',
  CertificatesAndExperience = 'Certificates & Experience',
  GeneralRequirements = 'General Requirements',
}
